import { gql } from "@apollo/client";

/**
 * Fetch unified chrome config (draft + published) and legacy fields for
 * the visual header & footer editor.
 */
export const GET_CHROME_CONFIG = gql`
  query ChromeConfig {
    currentTenant {
      id
      name
      domain
      chromeConfigDraft
      chromeConfigPublished
      navConfig
      footerConfig
      announcementConfig
      logoUrl
      footerLogoUrl
      brandName
      featureConfig
      socialLinks
      phone
      email
      addresses
      legalEntityName
      legalDisclaimers
    }
  }
`;
